import React from "react";
import AIAssistantChat from "../components/AIAssistantChat";
import AITutorChat from "../components/AITutorChat";

/**
 * AI Chat Page - A standalone chat window for the AI Tutor
 * This page allows users to interact with the AI tutor without being in a specific project context.
 */
const AIChatPage: React.FC = () => {
  // Use a default project ID for general chat without project context
  // The AIAssistantChat will handle the WebSocket connection
  const defaultProjectId = "general-chat";

  return (
    <div className="h-[100vh] flex flex-col">
      {/* Page Header */}
      {/* <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-blue-100 rounded-lg">
            <Bot className="w-6 h-6 text-blue-600" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-gray-900">
              AI Tutor
            </h1>
            <p className="text-sm text-gray-500">
              Your AI tutor for learning and projects
            </p>
          </div>
        </div>
      </div> */}

      {/* Chat Container */}
      <div className="flex-1 overflow-hidden">
        <AITutorChat projectId={defaultProjectId} isSidebar={true} />
      </div>
    </div>
  );
};

export default AIChatPage;
